module.exports = __webpack_public_path__ + "img/tan-lih-chen.dc274382.png";